import { render, staticRenderFns } from "./PreferredLanguageBubble.vue?vue&type=template&id=b08dbd50&"
import script from "./PreferredLanguageBubble.vue?vue&type=script&lang=js&"
export * from "./PreferredLanguageBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports